import { recordTrack } from '@saucelabs/sl-util-segmentio';

import * as actions from './actions';
import * as functions from './functions';
import * as selectors from './selectors';
import { LS_DASHBOARD_FILTERS } from './constants';

export const clearFilters = (payload) => (dispatch, getState) => {
  dispatch(actions.resetFilters(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const toggleStatus = (payload) => (dispatch, getState) => {
  dispatch(actions.toggleStatus(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const trackedToggleJobFilter = (status, metadata = {}) => (dispatch) => (
  Promise.all([
    dispatch(toggleStatus(status)),
    dispatch(recordTrack('Toggled job filter', { ...metadata, status })),
  ])
);

export const setPerformanceFilter = (payload) => (dispatch, getState) => {
  dispatch(actions.togglePerformance(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const selectOwner = (payload) => (dispatch, getState) => {
  dispatch(actions.selectOwner(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const clearOwner = (payload) => (dispatch, getState) => {
  dispatch(actions.clearOwner(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const clearStatuses = (payload) => (dispatch, getState) => {
  dispatch(actions.clearStatuses(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};


export const initializeFilters = ({
  fetchUsers,
  fetchTeams,
  ownerFilter,
  username,
}) => (dispatch, getState) => {
  const lsFilters = window.localStorage.getItem(
    LS_DASHBOARD_FILTERS,
  );

  if (lsFilters) {
    dispatch(actions.updateFiltersFromLS({ filters: lsFilters }));
  }

  const state = getState();
  const filtersUser = state.apps.jobs.filters.get('username');

  // if different user is logged in, we want to reset filters in localStorage to default state
  if (filtersUser !== username) {
    dispatch(clearFilters({ username }));
  }

  return Promise.all([
    fetchUsers ? dispatch(actions.getOrgUsers(username)) : Promise.resolve(),
    fetchTeams ? dispatch(actions.getTeamList()) : Promise.resolve(),
  ])
    .then(() => dispatch(actions.filtersInitialized()))
    .then(() => {
      // Sets initial filter value
      const usersList = getState().apps.jobs.filters.get('orgUsers');
      if (ownerFilter && usersList.includes(ownerFilter.data.name)) {
        dispatch(selectOwner(ownerFilter));
      }
    });
};
